const headerData = [{
		types: "selection",
		columnwidth: 40,
		fixed: 'left',
	}, {
		prop: "StatusName",
		label: "跟台状态",
		columnwidth: 80,
		fixed: 'left',
	}, {
		prop: "CICode",
		label: "单据号",
		columnwidth: 120,
		fixed: 'left',
	},
	{
		prop: "Look",
		label: "操作",
		columnwidth: 80,
		fixed: 'left',
	},
	{
		prop: "CreatorName",
		label: "打卡人",
		columnwidth: 140,
		fixed: 'left',
	},
	{
		prop: "SurgeryTimeName",
		label: "手术时间",
		columnwidth: 150,
	},
	{
		prop: "HospitalName",
		label: "医院",
		columnwidth: 200,
	},
	{
		prop: "TechnicalOffices",
		label: "科室",
		columnwidth: 80,
	},
	{
		prop: "Doctor",
		label: "术者",
		columnwidth: 80,
	},
	{
		prop: "PatientAgeName",
		label: "患者年龄段",
		columnwidth: 80,
	},
	{
		prop: "PatientSexName",
		label: "患者性别",
		columnwidth: 80,
	},
	{
		prop: "SurgeryTypeName",
		label: "手术类型",
		columnwidth: 140,
	},
	{
		prop: "ClockInTime",
		label: "打卡时间",
		columnwidth: 180,
	},
	{
		prop: "Address",
		label: "打卡地点",
		columnwidth: 220,
	}
];
export default headerData;